import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";

const LoadingWithMessage = ({ loadingProgress }) => {
  const [message, setMessage] = useState("Please wait...");

  useEffect(() => {
    if (!loadingProgress) return;

    const messages = [
      { time: 0, text: "Please wait while fetching student details..." },
      { time: 4000, text: "Still fetching student details, almost there..." },
      { time: 10000, text: "This is taking longer than expected, please hold on..." },
      { time: 15000, text: "Still working on fetching the student details..." },
      { time: 20000, text: "It’s taking a bit longer than usual — thanks for your patience!" },
      { time: 25000, text: "We’re still processing the request. Please hang tight..." },
      { time: 30000, text: "Sorry for the delay — the student details will appear shortly." },
    ];

    const timers = messages.map(({ time, text }) =>
      setTimeout(() => setMessage(text), time)
    );

    return () => timers.forEach(clearTimeout);
  }, [loadingProgress]);

  return (
    <>
      {loadingProgress && (
        <div className="text-center py-5">
          {/* <Spinner animation="border" /> */}
          <div className="mt-3 text-dark fw-semibold">{message}</div>
        </div>
      )}
    </>
  );
};

export default LoadingWithMessage;